export const Constants = {
  useNativeDriver: !process.env.JEST_WORKER_ID,
};
